import { Callout } from "./callout";

type Props = {
  onRefresh: () => void;
};

export function CalloutRefresh({ onRefresh }: Props) {
  return (
    <Callout
      icon="alert-circle-outline"
      action="Retry"
      title="Connection issues"
      message="There was a problem with your connection. Please try again."
      onPress={onRefresh}
    />
  );
}
